import gql from 'graphql-tag';

const updateVideoAtomicQuery = gql`
  mutation UpdateVideoAtomic($input: VideoDeltaInput!, $videoId: String!) {
    updateVideoAtomic(input: $input, videoId: $videoId)
  }
`;

const updateVideoAtomic = () => ({
  mutation: updateVideoAtomicQuery,
  module: 'video',
  buildVariables: (data) => {
    const { inputs, videoId } = data;
    return { input: inputs, videoId };
  }
});

export default updateVideoAtomic;